/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import Moment from 'moment';
import {MESSAGES} from '../../../../constants/APP_CONSTANTS';
import { Icon } from '@pearson-components/elements-sdk/build/dist.elements-sdk';

export default class Notes extends Component {
    static get propTypes() {
        return {
            notes: PropTypes.array,
            holds: PropTypes.array,
            activeCollection: PropTypes.object,
            fetchNotes: PropTypes.func,
            readOnly:PropTypes.bool
        };
    }
    constructor (props) {
        super(props);
        this.state = {
            currentDateTime: Moment.utc(new Date()).local().format("MM-DD-YYYY HH:mm:ss"),
            isNotesModalActive: false,
            newNote: {
                credit : false,
                rights : false,
                cover : false,
                other : false,
                note : ''
            }
        };
        this.showModal=this.showModal.bind(this);
    }

    componentDidMount() {
        this.props.loadCurrentHoldsStatus();
    }

    componentDidUpdate(prevProps) {
        if (this.props.holds != prevProps.holds) {
            this.props.loadCurrentHoldsStatus();
        }
    }
    showModal(){
        this.props.showNoteModal();
    }
  
    render() {

        let noteCount = this.props.notes ? this.props.notes.length : 0;
        noteCount = this.props.activeCollection && this.props.activeCollection.hasOMResources ? noteCount + 1  : noteCount;
        noteCount = this.props.activeCollection && this.props.activeCollection.has3PResources ? noteCount + 1: noteCount;

        return (
            <div className="notes-container">
                <label id="total-notes">{noteCount ? (noteCount === 1 ? "1 Note" : noteCount+ " Notes"): "0 Notes" }</label>
                {!this.props.readOnly && <a href="#" className="add-note" onClick={this.showModal}>Add note<span className="add-icon"><Icon name='item-add-18'/></span></a>}
                <div>
                    {
                        <div className="notes">
                            {(this.props.notes && this.props.notes.length > 0) ?
                                <div >
                                    {this.props.notes.map((notes, index) =>
                                        <div key={index} className="note" >
                                            <span className="left-cell"> <b>{Moment.utc(notes.createdTimestamp).local().format("MM-DD-YYYY HH:mm:ss") + " "
                                            } [{notes.userFirstName}] : </b></span><div className="right-cell">{
                                                notes.collectionNoteHolds && notes.collectionNoteHolds.length > 0 && notes.collectionNoteHolds.map((holds) =>{
                                                    return  <span className={(holds.selected) ? 'tableBox orangeBox' : 'tableBox'} >{holds.hold}</span>;
                                                })
                                            } <span id= "note" className="noteBody">{notes.body}  </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                : null}

                            {
                                (this.props.collection && this.props.collection.hasOMResources) && <div className="note" >
                                    <span className="left-cell"><b>{ this.state.currentDateTime + " "
                                    } : </b></span><div className="right-cell">
                                        <span id= "note" className="noteBody">{MESSAGES['book_has_om']}  </span></div>
                                </div>
                            }

                            {
                                (this.props.activeCollection && this.props.activeCollection.has3PResources) && <div className="note" >
                                    <span className="left-cell"><b> {this.state.currentDateTime + " "
                                    } : </b></span><div className="right-cell">
                                        <span id= "note" className="noteBody">{MESSAGES['book_has_3p']}  </span></div>
                                </div>
                            }

                        </div>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/BookDetailsComponents/Notes.js